import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<span class=\"name\">\n  {{this.label}}\n</span>\n\n{{#if this.item.colors}}\n  <div class=\"palettes\" style={{this.backgroundColor}}>\n    {{this.palettes}}\n  </div>\n{{/if}}", {
  moduleName: "select-kit/components/color-palettes/color-palettes-row.hbs"
});